import { Button, Col, Drawer, Menu, MenuProps, Row } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import React, { useCallback, useEffect, useState } from 'react';
import styles from './AppNavbar.module.scss';
import SwitchLan from '@components/switch-lan/SwichLan';
import { useRouter } from 'next/router';
import HkjcLogo from '@public/images/hkjc_logo_eng.svg';
import HkjcLogoChi from '@public/images/hkjc_logo_chi.svg';
import { AppLanguage } from '@src/common/models/app-language';

type Props = { menuInfos: any[] };

export default function AppNavbar({ menuInfos }: Props) {
    const [verticalMenuWidth, setVerticalMenuWidth] = useState(0);
    const [menuOpend, setMenuOpend] = useState(false);
    const router = useRouter();
    useEffect(() => {
        setVerticalMenuWidth(document.body.clientWidth);
    }, []);
    const showMenu = () => {
        setMenuOpend(true);
    };
    const onDrawerClose = () => {
        setMenuOpend(false);
    };
    const menuItems = menuInfos.map((item) => {
        return {
            ...item,
            label: (
                <a href={item.link} target='_blank' rel='noopener noreferrer'>
                    {item.label}
                </a>
            ),
        };
    });

    return (
        <Row className={styles.navbar}>
            <Col xs={0} md={24}>
                <Row justify='space-between'>
                    <Col span={21}>
                        <Menu className='h-menu' items={menuItems} mode='horizontal'></Menu>
                    </Col>
                    <Col>
                        <div className={styles['lang-container']}>
                            <SwitchLan></SwitchLan>
                        </div>
                    </Col>
                </Row>
            </Col>
            <Col span={24}>
                <Row className={styles['logo-bar']}>
                    <Col xs={0} md={6}>
                        <div className={styles['logo-container']}>
                            <div className={styles['logo']}>
                                {router.locale === AppLanguage.en_us ? (
                                    <HkjcLogo />
                                ) : (
                                    <HkjcLogoChi height='50' />
                                )}
                            </div>
                        </div>
                    </Col>
                    <Col md={0}>
                        <div className={styles['logo-container']}>
                            <div className={styles['logo']} onClick={showMenu}>
                                {/* <HkjcLogo prefix='mobile-' /> */}
                                {router.locale === AppLanguage.en_us ? (
                                    <HkjcLogo prefix='mobile-' />
                                ) : (
                                    <HkjcLogoChi prefix='mobile-' height='50' />
                                )}
                            </div>
                        </div>
                    </Col>
                    <Col flex='auto'></Col>
                    <Col md={0}>
                        <SwitchLan sm></SwitchLan>
                    </Col>
                </Row>
                <Drawer
                    className='navi-drawer'
                    placement='left'
                    onClose={onDrawerClose}
                    open={menuOpend}
                    closable={false}
                    width=''
                >
                    <Row className={styles['logo-bar']}>
                        <Col md={0}>
                            <Button
                                className='m-close-menu-btn'
                                onClick={() => setMenuOpend(false)}
                                type='text'
                                icon={<CloseOutlined />}
                            ></Button>
                        </Col>
                    </Row>
                    <Menu className='navi-verti-menu' items={menuItems} mode='inline'></Menu>
                </Drawer>
            </Col>
        </Row>
    );
}
